// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circles-width {
  width: 30px;
  height: 30px;
}

.text-black {
  color: #000000;
}

.text-white {
  color: #ffffff;
}

.text-disabled {
  color: #b6cde7;
}

.text-notstarted {
  color: #0a56ae;
}

.bg-disabled {
  background-color: #ffffff;
}

.border-disabled {
  border: 1px solid #b6cde7;
}

.bg-in-progress {
  background-color: #0a56ae;
}

.border-in-progress {
  border: 1px solid #0a56ae;
}

.bg-completed {
  background-color: #10b967;
}

.border-completed {
  border: 1px solid #10b967;
}

.bg-withdrawn {
  background-color: #992ef2;
}

.border-withdrawn {
  border: 1px solid #992ef2;
}

.bg-rejected {
  background-color: #d90909;
}

.border-rejected {
  border: 1px solid #d90909;
}

.bg-skipped {
  background-color: #868384;
}

.border-skipped {
  border: 1px solid #868384;
}

.bg-notstarted {
  background-color: #ffffff;
}

.border-notstarted {
  border: 1px solid #0a56ae;
}

.overview-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.overview-step-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.overview-progress-line {
  border: 1px solid;
  width: 24px;
}

.overview-disabled-line {
  border: 1px dashed #b6cde7;
}

.overview-not-started-line {
  border: 1px dashed #0a56ae;
}

.overview-inprogress-line {
  border: 1px solid #0a56ae;
}

.overview-completed-line {
  border: 1px solid #10b967;
}

.overview-rejected-line {
  border: 1px solid #d90909;
}

.overview-withdrawn-line {
  border: 1px solid #992ef2;
}

.overview-skipped-line {
  border: 1px solid #868384;
}`, "",{"version":3,"sources":["webpack://./../job/src/components/JobOverview/OverviewStepComponent.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".circles-width {\n  width: 30px;\n  height: 30px;\n}\n\n.text-black {\n  color: #000000;\n}\n\n.text-white {\n  color: #ffffff;\n}\n\n.text-disabled {\n  color: #b6cde7;\n}\n\n.text-notstarted {\n  color: #0a56ae;\n}\n\n.bg-disabled {\n  background-color: #ffffff;\n}\n\n.border-disabled {\n  border: 1px solid #b6cde7;\n}\n\n.bg-in-progress {\n  background-color: #0a56ae;\n}\n\n.border-in-progress {\n  border: 1px solid #0a56ae;\n}\n\n.bg-completed {\n  background-color: #10b967;\n}\n\n.border-completed {\n  border: 1px solid #10b967;\n}\n\n.bg-withdrawn {\n  background-color: #992ef2;\n}\n\n.border-withdrawn {\n  border: 1px solid #992ef2;\n}\n\n.bg-rejected {\n  background-color: #d90909;\n}\n\n.border-rejected {\n  border: 1px solid #d90909;\n}\n\n.bg-skipped {\n  background-color: #868384;\n}\n\n.border-skipped {\n  border: 1px solid #868384;\n}\n\n.bg-notstarted {\n  background-color: #ffffff;\n}\n\n.border-notstarted {\n  border: 1px solid #0a56ae;\n}\n\n.overview-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.overview-step-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.overview-progress-line {\n  border: 1px solid;\n  width: 24px;\n}\n\n.overview-disabled-line {\n  border: 1px dashed #b6cde7;\n}\n\n.overview-not-started-line {\n  border: 1px dashed #0a56ae;\n}\n\n.overview-inprogress-line {\n  border: 1px solid #0a56ae;\n}\n\n.overview-completed-line {\n  border: 1px solid #10b967;\n}\n\n.overview-rejected-line {\n  border: 1px solid #d90909;\n}\n\n.overview-withdrawn-line {\n  border: 1px solid #992ef2;\n}\n\n.overview-skipped-line {\n  border: 1px solid #868384;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
